import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, EMPTY } from "rxjs";

import { environment } from "environments/environment";
import { CurrentService } from "app/services/current.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private currentService: CurrentService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.currentService.currentUser.value;
    const isLoggedIn = currentUser && currentUser.refreshToken;
    const isApiUrl = request.url.startsWith(environment.apiUrl);

    // Si une déconnexion est en cours, ne pas ajouter le token d'auth
    // mais laisser passer les requêtes (elles seront sans auth)
    if (this.currentService.isLoggingOut) {
      // Laisser passer sans token - les endpoints publics fonctionneront
      // Les endpoints protégés retourneront 401 mais c'est normal pendant la déconnexion
      return next.handle(request);
    }

    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.refreshToken}`,
        },
      });
    }

    return next.handle(request);
  }
}
